<template>
  <div class="data-field-rich-text"
       :class="{ 'is-border': isBorderStyle }">
    <template v-if="content">
      <template v-if="isBorderStyle">
        <div class="rich-text-border-wrap">
          <RichTextPreview :html="content"></RichTextPreview>
        </div>
      </template>
      <template v-else>
        <RichTextPreview :html="content"></RichTextPreview>
      </template>
    </template>
    <template v-else>
      <span class="field-empty">-</span>
    </template>
  </div>
</template>

<script>
import RichTextPreview from '../../../widgets/RichTextPreview'
export default {
  name: 'RichTextField',
  inject: ['$formPanel'],
  components: {
    RichTextPreview
  },
  props: {
    content: String
  },
  computed: {
    isBorderStyle () {
      return this.$formPanel && this.$formPanel.isBorderStyle
    }
  }
}
</script>

<style lang="scss" scoped>
.data-field-rich-text {
  .field-empty {
    font-size: 13px;
    color: #909399;
  }

  &.is-border {
    .rich-text-border-wrap {
      padding: 8px 12px;
      border: 1px solid #F3F5F7;
      border-radius: 4px;
      background-color: #F3F5F7;
      max-height: 200px;
      overflow: auto;
    }
  }
}
</style>
